import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Avatar, Card, Image, Spin, Tag, Tooltip } from "antd";
import { FlagOutlined, GlobalOutlined, HomeOutlined, PhoneOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import CardImgItem from "./CardImage";
import CardImageItem from "./CardImage";

const DetailUser = ({ modal, setModal, toggle, selectedUser }) => {

    const { firstName, lastName, email, phone, address, cniNumber, licenseNumber, createdAt, updatedAt, status, role, vehicle, fileName } = selectedUser || {};
    const roleName = role?.name || "-";
    const { name, model, description, transmission, speed, registrationNumber, commissioningDate, vin, mileage, actualUserId } = vehicle || {}; 

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "900px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <span>Détail de l'utilisateur {lastName} </span>
      </ModalHeader>

      <ModalBody>
        <div className="text-center mb-4">
          <Avatar size={150} style={{ width: "150px", height: "150px", overflow: "hidden" }}>
            <CardImageItem fileName = {fileName} />
          </Avatar>
        </div>

        <div className="text-center mb-4">
          <h4>{firstName} {lastName} </h4>
          <p>{roleName || " - "}</p>
        </div>

        <Card className="card-animate" title="Informations Générales" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <Row gutter={16}>
            <Col span={6}>
              <Tooltip title="Statut de l'utilisateur ">
                <Tag color={status === 'ACTIVE' ? 'green' : 'volcano'} icon={<TagOutlined />}> Statut: {status === 'ACTIVE' ? 'Actif' : 'Inactif'}</Tag>
              </Tooltip>
            </Col>
            <Col span={6}>
              <Tooltip title="Adresse email">
                <Tag size="large" color="blue" icon={<GlobalOutlined />}>Email : {email || 'Inconnu'}</Tag>

              </Tooltip>
            </Col>
            <Col span={6}>
              <Tooltip title="Numéro de téléphone">
                <Tag color="purple" icon={<PhoneOutlined />}>Téléphone : {phone || 'Non spécifié'}</Tag>
              </Tooltip>
            </Col>
            <Col span={6}>
              <Tooltip title="Adresse de l'utilisateur">
                <Tag color="cyan" icon={<HomeOutlined />}>Adresse : {address || 'Inconnue'}</Tag>
              </Tooltip>
            </Col>
          </Row>
        </Card>

        <Card className="card-animate" title="Détails de Compte" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <Row gutter={16}>
            <Col span={12}>
              <div>
                <strong>Numéro d'identité : </strong> <span>{ cniNumber || '-' }</span>
              </div>
            </Col>

            <Col span={12}>
              <div>
                <strong>Permis : </strong> <span>{ licenseNumber || '-'}</span>
              </div>
            </Col>
            <Col span={12}>
              <div>
                <strong>Permis : </strong> <span>{ licenseNumber || '-'}</span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <div>
                <strong>Date de création : </strong> <span>{formatDate(createdAt)}</span>
              </div>
            </Col>

            <Col span={12}>
              <div>
                <strong>Date de modification : </strong> <span>{formatDate(updatedAt)}</span>
              </div>
            </Col>
            <Col span={12}>
              <div>
                <strong>Date de modification : </strong> <span>{formatDate(updatedAt)}</span>
              </div>
            </Col>
          </Row>
        </Card>

        {
            vehicle && (
                <Card className="card-animate" title="Voiture rattachée" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
                    <Row gutter={16}>
                        <Col span={5}>
                        <div>
                            <strong>Nom : </strong> <span>{ name || '-' }</span>
                        </div>
                        </Col>

                        <Col span={5}>
                        <div>
                            <strong>Model : </strong> <span>{ model || '-'}</span>
                        </div>
                        </Col>
                        <Col span={5}>
                        <div>
                            <strong>Numéro plaque : </strong> <span>{ registrationNumber || '-' }</span>
                        </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={5}>
                        <div>
                            <strong>Vin : </strong> <span>{ vin || '-' }</span>
                        </div>
                        </Col>

                        <Col span={5}>
                        <div>
                            <strong>Kilométrage : </strong> <span>{ mileage || '-'}</span>
                        </div>
                        </Col>

                        <Col span={5}>
                        <div>
                            <strong>Date de mise en service : </strong> <span>{ commissioningDate || '-'}</span>
                        </div>
                        </Col>
                    </Row>
                </Card>
            )
        }
        
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={() => setModal(false)}>Fermer</Button>
      </ModalFooter>
    </Modal>
  );

};

export default DetailUser;
